import { useState, useEffect } from "react";
//tablets and smaller devices are considered mobile for CAM purposes
  const CAM_TABLET_BREAKPOINT = 1024;

export const useCamIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => window.innerWidth <= CAM_TABLET_BREAKPOINT
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${CAM_TABLET_BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    if (mq.addEventListener) {
      mq.addEventListener("change", handler);
    } else {
      (mq as any).addListener(handler);
    }

    return () => {
      if (mq.removeEventListener) {
        mq.removeEventListener("change", handler);
      } else {
        (mq as any).removeListener(handler);
      }
    };
  }, []);

  return isMobile;
};